import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default (editor: Editor, opts: RequiredPluginOptions) => {
  const { block, label, id } = opts;

  if (block) {
    editor.Blocks.add("categories", {
      media: `
<svg width="44" height="44" class="mx-auto" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M36.6667 7.33341H7.33334C6.84711 7.33341 6.3808 7.52657 6.03698 7.87039C5.69316 8.2142 5.50001 8.68052 5.50001 9.16675V34.8334C5.50001 35.3196 5.69316 35.786 6.03698 36.1298C6.3808 36.4736 6.84711 36.6667 7.33334 36.6667H36.6667C37.1529 36.6667 37.6192 36.4736 37.963 36.1298C38.3069 35.786 38.5 35.3196 38.5 34.8334V9.16675C38.5 8.68052 38.3069 8.2142 37.963 7.87039C37.6192 7.52657 37.1529 7.33341 36.6667 7.33341ZM7.33334 3.66675C5.87465 3.66675 4.47571 4.24621 3.44426 5.27766C2.41281 6.30911 1.83334 7.70806 1.83334 9.16675V34.8334C1.83334 36.2921 2.41281 37.6911 3.44426 38.7225C4.47571 39.754 5.87465 40.3334 7.33334 40.3334H36.6667C38.1254 40.3334 39.5243 39.754 40.5558 38.7225C41.5872 37.6911 42.1667 36.2921 42.1667 34.8334V9.16675C42.1667 7.70806 41.5872 6.30911 40.5558 5.27766C39.5243 4.24621 38.1254 3.66675 36.6667 3.66675H7.33334Z" fill="currentColor"/>
<path d="M9.9375 12.875H14V16H9V11.9375H11.1875L11.8125 12.5625H9.625V15.375H9.9375V12.875Z" fill="currentColor"/>
<path d="M20.9375 12.9375H25V16.0625H20V12H22.1875L22.8125 12.625H20.625V15.4375H20.9375V12.9375Z" fill="currentColor"/>
<path d="M30.9375 12.9375H35V16.0625H30V12H32.1875L32.8125 12.625H30.625V15.4375H30.9375V12.9375Z" fill="currentColor"/>
<path d="M9.9375 19.9375H14V23.0625H9V19H11.1875L11.8125 19.625H9.625V22.4375H9.9375V19.9375Z" fill="currentColor"/>
<path d="M20.9375 19.9375H25V23.0625H20V19H22.1875L22.8125 19.625H20.625V22.4375H20.9375V19.9375Z" fill="currentColor"/>
<path d="M30.9375 19.9375H35V23.0625H30V19H32.1875L32.8125 19.625H30.625V22.4375H30.9375V19.9375Z" fill="currentColor"/>
<path d="M9.9375 26.9375H14V30.0625H9V26H11.1875L11.8125 26.625H9.625V29.4375H9.9375V26.9375Z" fill="currentColor"/>
<path d="M20.9375 26.9375H25V30.0625H20V26H22.1875L22.8125 26.625H20.625V29.4375H20.9375V26.9375Z" fill="currentColor"/>
<path d="M30.9375 26.9375H35V30.0625H30V26H32.1875L32.8125 26.625H30.625V29.4375H30.9375V26.9375Z" fill="currentColor"/>
</svg>
`,
      label,
      category: "common",
      select: true,
      content: { type: "categories" },
      ...block,
    });
  }
};
